import { z } from 'zod';

import { NotificationChannelSchema, NotificationStatusSchema } from './enums';

// ============================================================================
// Send Notification — POST /api/v1/notifications
// ============================================================================

export const SendNotificationRequestSchema = z.object({
  channel: NotificationChannelSchema,
  recipient: z.string().min(1).max(255),
  templateId: z.string().min(1).max(100),
  data: z.record(z.unknown()).optional(),
  subject: z.string().max(255).optional(),
});

export type SendNotificationRequest = z.infer<typeof SendNotificationRequestSchema>;

export const SendNotificationResponseSchema = z.object({
  id: z.string().uuid(),
  status: NotificationStatusSchema,
  channel: NotificationChannelSchema,
});

export type SendNotificationResponse = z.infer<typeof SendNotificationResponseSchema>;

// ============================================================================
// Get Notification Status — GET /api/v1/notifications/:id
// ============================================================================

export const GetNotificationStatusResponseSchema = z.object({
  id: z.string().uuid(),
  channel: NotificationChannelSchema,
  recipient: z.string(),
  status: NotificationStatusSchema,
  sentAt: z.string().datetime().nullable(),
  errorMessage: z.string().nullable(),
  attempts: z.number().int(),
});

export type GetNotificationStatusResponse = z.infer<typeof GetNotificationStatusResponseSchema>;
